const firebaseConfig = {
  apiKey: "AIzaSyCHJm-LpOzXk2FGD3-DjECSS_C-4EF3_RU",
  authDomain: "cars-zone-b1414.firebaseapp.com",
  projectId: "cars-zone-b1414",
  storageBucket: "cars-zone-b1414.appspot.com",
  messagingSenderId: "944480031536",
  appId: "1:944480031536:web:581ebbcbf6ddb37a9e2ef5"
};

export default firebaseConfig;




/* 
  const firebaseConfig = {
  apiKey: "AIzaSyAyAuVyZQ7obFzFMsZoteuTrzYohcZTXjU",
  authDomain: "assignment-12-76cbb.firebaseapp.com",
  projectId: "assignment-12-76cbb",
  storageBucket: "assignment-12-76cbb.appspot.com",
  messagingSenderId: "137128196145",
  appId: "1:137128196145:web:bd54e646b228f90ccb3d10",
};

export default firebaseConfig;
*/

